export const pickBy = (object: any, predicate: (value: any, key: any) => boolean): any => {
    if (!object || typeof object !== 'object') {
        throw new TypeError('Expected an object');
    }
    if (typeof predicate !== 'function') {
        throw new TypeError('Expected a function');
    }

    return Object.keys(object).reduce((result: any, key: string) => {
        if (predicate(object[key], key)) {
            result[key] = object[key];
        }
        return result;
    }, {});
};
